module.exports = __webpack_public_path__ + "static/media/DecCreditcardGettingStarted.68c3dccb.tsx";